"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLayoutConfig = void 0;
const camelize_1 = require("./camelize");
const validateLayoutConfig = (layoutConfig, mediaAssets, translations, stimulus) => {
    const messages = [];
    if (layoutConfig.playAudioOnLoad) {
        // we expect audio file to be present
        if (!stimulus.audioFile) {
            messages.push('Missing audioFile string');
        }
        else {
            if (typeof stimulus.audioFile === 'string') {
                const audioAsset = (0, camelize_1.camelize)(stimulus.audioFile);
                if (!mediaAssets.audio[audioAsset]) {
                    messages.push(`Missing audio asset: ${audioAsset}`);
                }
                if (layoutConfig.prompt.enabled && !translations[audioAsset]) {
                    // check if prompt with translation is present
                    messages.push(`Missing prompt for: ${audioAsset}`);
                }
            }
            else {
                const audioAssets = stimulus.audioFile.map((audio) => (0, camelize_1.camelize)(audio));
                audioAssets.forEach((audioAsset) => {
                    if (!mediaAssets.audio[audioAsset]) {
                        messages.push(`Missing audio asset: ${audioAsset}`);
                    }
                });
            }
        }
    }
    if (layoutConfig.isImageButtonResponse) {
        // check if all images are present
        layoutConfig.response.values.forEach((c) => {
            const imageAsset = (0, camelize_1.camelize)(c);
            if (!imageAsset) {
                messages.push(`Missing image button string: ${imageAsset}`);
            }
            if (!mediaAssets.images[imageAsset]) {
                messages.push(`Missing imageAsset: ${imageAsset}`);
            }
            // staggered buttons
            if (layoutConfig.isStaggered && !mediaAssets.audio[imageAsset]) {
                // check if audio is present for all buttons
                messages.push(`Missing audio for staggered button: ${imageAsset}`);
            }
        });
    }
    return messages;
};
exports.validateLayoutConfig = validateLayoutConfig;
